import React from 'react';
import { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { MyButton, MyModalDialog, MyInputLabel, MyHead2 } from './UI.jsx';
import { useSave } from '../../context/SaveContext.jsx';
import { createDeck, createDeckInfo } from '../../context/SaveData.js';

export const DeckModal = ({ onClose, setDeck }) =>
{
	const { t } = useTranslation();

	const [deckName, setDeckName] = useState("");
	const {deckList, saveDeckList, saveDeck} = useSave();

	const onClickNewDeck = async () => {
		const newDeck = {
			...createDeck(),
			name: deckName
		};
		const newDeckInfo = createDeckInfo(newDeck);
	
		await saveDeckList([...deckList, newDeckInfo]);
		await saveDeck(newDeck);

		onClose();
	};

	return (
		<MyModalDialog
			title={t("MyDeck_AddDeck")}
			body={
				<div>
					<MyHead2>{t("MyDeck_DeckName")}</MyHead2>
					<MyInputLabel
						placeholder={t("MyDeck_InputDeckName")}
						value={deckName}
						setValue={setDeckName}
					/>
				</div>
			}
			footer={
				<div>
					<MyButton onClick={onClickNewDeck} text={t("Common_OK")} disabled={!deckName.trim()} />
				</div>
			}
			onClose={onClose}
		/>
	);
};

export const ColumnModal = ({ onClose, setDeck }) =>
{

};